import { ChallengeSavedStatusIcon } from '@/components/challenge/components';
import { TSaveStatus } from '@/hooks/useFieldSaveStatus';
import { CircularProgress, InputAdornment } from '@mui/material';

const STATUS_ICON_SIZE = 14;

// Returns `undefined` (not a null-rendering element) when there's nothing
// to show — MUI's OutlinedInput reserves extra padding for `endAdornment`
// based on whether the prop itself is truthy, not on what it renders, so a
// stub element here would permanently widen every field's padding.
export const getStatusAdornment = (status: TSaveStatus | undefined) => {
  if (!status || status === 'error') {
    return undefined;
  }

  return (
    <InputAdornment position="end">
      {status === 'saving' && <CircularProgress size={STATUS_ICON_SIZE} />}
      {status === 'saved' && <ChallengeSavedStatusIcon />}
    </InputAdornment>
  );
};
